import { CircularProgress, Chip, Avatar } from '@material-ui/core';
import React, { useMemo, useState } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import CalendarEventModal from './CalendarEventModal';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { Add } from '@material-ui/icons';

const DailyCalendar = ({ events, loading, week, refresh, setRefresh, printView }) => {
	const [eventModalOpen, setEventModalOpen] = useState(false);
	const [currentSelectedEvent, setCurrentSelectedEvent] = useState(null);
	const navigate = useNavigate();
	const today = moment().startOf('day');
	const currentDay = moment(week[0]);

	const goToCreateEvent = () => {
		navigate('/calendar-addevent', { state: { date: currentDay?.format('YYYY-MM-DD') } });
	};
	return (
		<div>
			{!printView ? (
				<CalendarEventModal
					event={currentSelectedEvent}
					open={eventModalOpen}
					refresh={refresh}
					setOpen={setEventModalOpen}
					setRefresh={setRefresh}
				/>
			) : null}

			{loading ? (
				<div className="loading-spinner">
					<CircularProgress size={35} />
				</div>
			) : null}
			{!loading && !events.length ? (
				<div className="no-schedules">
					<p>No Events</p>
				</div>
			) : null}
			{!loading && events ? (
				<div className="flex flex-col">
					{events.map((event, index) => {
						return (
							<div className="border-b flex items-center py-16" key={`${event.id}-${index}`}>
								<DailyEventChip
									event={event}
									refresh={refresh}
									setCurrentSelectedEvent={setCurrentSelectedEvent}
									setEventModalOpen={setEventModalOpen}
									setRefresh={setRefresh}
								/>
							</div>
						);
					})}
				</div>
			) : null}
			{currentDay.isSameOrAfter(today) ? (
				<div className="flex items-center justify-center pt-8 sm:pt-16 md:pt-32">
					<CustomButton onClick={goToCreateEvent} width={120}>
						<div className="flex items-center justify-center">
							<Add />
							Add Event
						</div>
					</CustomButton>
				</div>
			) : null}
		</div>
	);
};

const DailyEventChip = ({ event, setEventModalOpen, setCurrentSelectedEvent }) => {
	const handleOpenEventModal = () => {
		setEventModalOpen(true);
		setCurrentSelectedEvent(event);
	};

	const randomNumber = useMemo(() => {
		return Math.ceil(Math.random() * 6);
	}, [event.id]);

	const isCustomEvent = event?.type === '39';
	return (
		<Chip
			avatar={
				<Avatar alt={event.event_type.type} src={event.event_type.icon_url} style={{ width: '46px', height: '46px' }} />
			}
			className={`event-random-${randomNumber} cursor-pointer mx-auto event-schedule-pill`}
			label={isCustomEvent ? event?.custom_type : event?.event_type?.type}
			onClick={handleOpenEventModal}
		/>
	);
};

export default DailyCalendar;
